import 'angular:locale/data:de';
import 'angular:locale/data:ja';
import 'angular:locale/data:en-GB';
import 'angular:locale/data:en';
import './apps/ng-partner-shell/src/polyfills.ts';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
